import styled from 'styled-components';

export const CardImage = styled.img`
  width: 30px;
  height: 30px;
  margin: 10px 0;
`;
